import { render, staticRenderFns } from "./TeamNav.vue?vue&type=template&id=7c2e6d28&lang=pug&"
import script from "./TeamNav.vue?vue&type=script&lang=js&"
export * from "./TeamNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports